import React, {useEffect, useState} from 'react';

import classNames from 'classnames';

import {Count} from './../count';
import {DataInfo, IDataInfoProps} from './../data-info';
import {ITabsNavItemProps, Tabs, TabsItem} from './../tabs';
import {Filter, IFilterProps} from './../forms/filter';
import {FeedbackAnswers, IFeedbackAnswersProps} from '../feedback-answers';

export interface IFeedbackProps {
    items: IFeedbackItemProps[] | IDataInfoProps;
    aspectRatio?: boolean;
    className?: string;
    filter?: IFilterProps;
}

export interface IFeedbackItemProps extends ITabsNavItemProps {
    answers: IFeedbackAnswersProps;
    title: string;
    count?: number,
    question?: string;
}

const Feedback = (props: IFeedbackProps): JSX.Element => {
    const hasData = (data: IFeedbackItemProps[] | IDataInfoProps): data is IFeedbackItemProps[] => (data as IFeedbackItemProps[]).length > 0;
    const className: string = classNames(
        'feedback',
        {
            'feedback--aspect-ratio': props.aspectRatio,
        },
        props.className,
    );

    const renderLabel: (item: IFeedbackItemProps) => JSX.Element = (item: IFeedbackItemProps) => (
        <div className="feedback__label">
            <div className="feedback__label-inner">
                <span className="feedback__title text-small">{item.title}</span>
                {item.count &&
                    <Count
                        className="feedback__count"
                        color={item.count > 0 ? 'red' : 'grey'}
                        number={item.count}
                        size={'sm'}
                    />
                }
            </div>
            <p className="feedback__question">{item.question}</p>
        </div>
    );

    const tabItems: ITabsNavItemProps[] = hasData(props.items) ? props.items.map((item: IFeedbackItemProps) => (
        {
            ...item,
            label: renderLabel(item),
        }
    )) : [];

    const [openTab, setOpenTab] = useState<string>(hasData(props.items) ? props.items[0].id : '');

    useEffect(() => {
        if (hasData(props.items) && !props.items.find(
            (item) => item.id === openTab,
        )) {
            setOpenTab(props.items[0].id);
        }
    }, [props.items]);

    return (
        <div className={className}>
            <div className="feedback__inner">
                {hasData(props.items) ? (
                    <React.Fragment>
                        {props.filter && <Filter {...props.filter} className="feedback__filter" hideLabel={true} />}
                        <Tabs className="feedback__tabs" value={openTab} onChange={(clickedTab): void => setOpenTab(clickedTab)} items={tabItems}>
                            {props.items.map((item: IFeedbackItemProps) => (
                                <TabsItem id={item.id} key={item.id} label={item.title}>
                                    <FeedbackAnswers {...item.answers}/>
                                </TabsItem>
                            ))}
                        </Tabs>
                    </React.Fragment>
                ) : <DataInfo {...props.items} />}
            </div>
        </div>
    );
};

export default Feedback;
